import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Spinner} from 'rambler-ui'
import HistoryIcon from 'components/icons/HistoryIcon'
import InfoSection from 'components/InfoSection'
import {SESSION} from 'utils/urls'
import withHistory from 'models/history'
import {formatTime, getNavigatorInfo} from 'utils/formatSessions'

const SideInfoHistory = ({recentSession}) => {
  let lastSession

  if (recentSession) {
    const displayTime = formatTime(recentSession.time)
    const browserTitle = getNavigatorInfo(recentSession.userAgent).title
    const browserName =
      browserTitle.indexOf('Браузер') > -1
        ? browserTitle.split(' ')[1]
        : browserTitle
    const city = recentSession.city

    lastSession = (
      <Fragment>
        Последний вход:
        <br />
        {displayTime}, {browserName}, {city}
      </Fragment>
    )
  }

  return (
    <InfoSection
      icon={<HistoryIcon />}
      title={<Link to={SESSION}>История входов</Link>}
      cerberId="profile::history::sessions"
    >
      {lastSession || <Spinner inline size={4} />}
    </InfoSection>
  )
}

SideInfoHistory.propTypes = {
  recentSession: PropTypes.shape({
    time: PropTypes.number.isRequired,
    userAgent: PropTypes.string.isRequired,
    ip: PropTypes.string.isRequired
  })
}

export default withHistory((chainId) => [chainId.default])(SideInfoHistory)
